import {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useAppSelector } from "../../store/hooks";
import { selectOffersChartRawData } from "../../features/productAnalyzer/productAnalyzer.selector";
import { formatChartRawDataToSeriesPoints } from "../../helpers";
import { OFFERS_CHART_DEFAULT_OPTIONS } from "./lib/constants";
import { Box } from "@mui/material";
// import { selectIsFreePlan } from "../../features/pricingPlans/pricingPlans.selector";
// import useChartOverlay from "../../hooks/useChartOverlay";

type TRef = {
  chart?: Highcharts.Chart | null;
};

export const OffersChart = forwardRef<TRef>((_, ref) => {
  // const { overlayRenderer } = useChartOverlay();

  const [options, setOptions] = useState<Highcharts.Options>(
    OFFERS_CHART_DEFAULT_OPTIONS,
  );

  const chartRef = useRef<HighchartsReact.RefObject>(null);

  const { offersChartRawData } = useAppSelector(selectOffersChartRawData);

  // const isFreePlan = useAppSelector(selectIsFreePlan);

  useImperativeHandle(
    ref,
    () => ({
      chart: chartRef.current?.chart,
    }),
    [],
  );

  useEffect(() => {
    if (!offersChartRawData.length) return;

    const series = formatChartRawDataToSeriesPoints(
      OFFERS_CHART_DEFAULT_OPTIONS.series,
      offersChartRawData,
    );

    const newOptions = {
      ...OFFERS_CHART_DEFAULT_OPTIONS,
      series,
    };

    // if (isFreePlan) {
    //   newOptions.chart = {
    //     ...OFFERS_CHART_DEFAULT_OPTIONS.chart,
    //     events: {
    //       render(this: Highcharts.Chart) {
    //         overlayRenderer({
    //           chart: this,
    //           title: "Offer, Rating Review Chart",
    //         });
    //       },
    //     },
    //   };
    // }

    setOptions(newOptions);
  }, [offersChartRawData]);

  if (
    !offersChartRawData.length ||
    (!offersChartRawData[0].length &&
      !offersChartRawData[1].length &&
      !offersChartRawData[2].length)
  )
    return null;

  return (
    <Box sx={{ position: "relative" }}>
      <HighchartsReact
        highcharts={Highcharts}
        options={options}
        ref={chartRef}
      />
    </Box>
  );
});

export default memo(OffersChart);
